module.exports = "i { \n    border-radius: 50%;\n    cursor: pointer;\n}\n\ni.background:hover {\n    background-color: #EEEEEE;  \n}\n\ni.cast-shadow:hover {\n    text-shadow: 1px 2px 2px #444;  \n}\n\n.popover {\n    max-width: 600px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/smart-tooltip/smart-tooltip.component.css
// module id = ./src/app/shared/components/smart-tooltip/smart-tooltip.component.css
// module chunks = main